module.exports = __webpack_public_path__ + "fonts/noto-sans-v7-latin-regularabc24b0f77dd16d0b4ea7cbe4a1082b0.woff2";